const INITIAL_STATE = { registro: {}, modoTela: 'lista', lista: [], listaPerfil: [], listaUnidade: [], listaOperacao: [] };

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
		case 'USUARIO_MODO_TELA':
            return { ...state,
				modoTela: action.payload.modo,
				registro: action.payload.registro
			};

        case 'USUARIO_LISTADO':
            return { ...state, lista: action.payload.data.filter(item => !item.id_cliente) };

        case 'USUARIO_PERFIL_SELECT_LISTADO':
			return {
				...state,
				listaPerfil: action.payload.data
			};

        case 'USUARIO_UNIDADE_SELECT_LISTADO':
			return {
				...state,
				listaUnidade: action.payload.data
			};

		case 'USUARIO_OPERACAO_SELECT_LISTADO':
			return {
				...state,
				listaOperacao: action.payload.data
			};

        default:
            return state;
    }
}
